<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix flex flex-b">
				<h4>内容配置</h4>
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
				<el-form-item label="" prop="name" :label-width="labelWidth">
					<QuillEditor :option="editorOption" :value="detailObject.value" @input='editorInput'></QuillEditor>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 150px;" @click="submitForm('ruleForm')">更新</el-button>
		</el-card>

	</div>
</template>

<script>
	import QuillEditor from '@/components/quill-editor'
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import {
		getConfig,
		setConfig
	} from "@/api/views"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				editdialogVisible: false,
				labelWidth: '150px',
				radio: '2',
				activeTab: 'first',
				imgDomain,
				total: 0,
				page_size: 9,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
				ruleForm: {
					name: '',
					region: '',
					resource: '',
					desc: '',
					jfRule: '',
					avatar: ''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}, ],
				},
				editorOption: {
					theme: 'snow', // 使用 snow 主题以显示顶部工具栏
					modules: {
						toolbar: [
							['image'] // 工具栏只保留图片插入功能
						]
					}
				}
			};
		},
		components: {
			CommonPagination,
			QuillEditor
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.user_uuid = uuid
			this.getConfig(uuid);
		},
		methods: {
			editorInput(e) {
				this.ruleForm.name = e
				this.detailObject.value = e
			},
			closeDialog() {},
			confirmDialog() {},
			addPointsDialog() {
				this.editdialogVisible = true
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.setConfig()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async setConfig() {
				const {
					status,
					data
				} = await setConfig(this.detailObject);
				if (status !== 200) return;
				this.$message.success('修改成功')
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.goBack()
			},
			handlePageChange(page) {
				this.page_index = page
				this.getDoubao()
			},
			handlePageChange1(page) {
				this.page_index1 = page
				this.getAiApplicationHistoryList()
			},
			handleClick(tab, event) {
				if (tab.name == 'second') {
					this.getAiApplicationHistoryList()
				}
				if (tab.name == 'first') {
					this.getDoubao()
				}
			},
			async getDoubao() {
				let postData = {
					page_size: this.page_size,
					page_index: this.page_index,
					user_uuid: this.user_uuid
				};
				const {
					status,
					data
				} = await getDoubao(postData);
				if (status !== 200) return;
				this.doubaoList = data.result.data;
				this.total = data.result.total;
			},
			async getAiApplicationHistoryList() {
				let postData = {
					page_size: this.page_size1,
					page_index: this.page_index1,
					user_uuid: this.user_uuid
				};
				const {
					status,
					data
				} = await getAiApplicationHistoryList(postData);
				if (status !== 200) return;
				this.hisLists = data.result.data;
				this.total1 = data.result.total;
			},
			goBack() {
				this.$router.go(-1)
			},
			async getConfig(uuid) {
				const {
					data,
					status
				} = await getConfig({
					key: 'SIDE_AGREEMENT'
				});
				if (status === 200) {
					this.detailObject = data.result;
				}
			},
			handleClickBack() {
				this.$router.back(-1);
			},

		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}
</style>